import { View } from 'react-big-calendar';
import styled from 'styled-components';

import { Row } from 'enable-ui';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const CalendarContainer = styled(Row)<{ view: View }>`
  gap: 32px;
  position: relative;
  width: 79.3%;

  .rbc-calendar {
    height: ${({ view }) => (view !== 'month' ? 'calc(100vh - 112px)' : '100%')};
  }

  .rbc-calendar {
    margin-right: 32px;
  }

  .rbc-month-view,
  .rbc-time-view {
    margin-top: 0 !important;
  }

  .rbc-month-view {
    min-height: calc(100vh - 166px);
  }

  .rbc-header {
    span {
      font-size: 14px !important;
      font-weight: 600;
      color: ${COLOR_CONFIG['neutral-text']};
      line-height: calc(20 / 14);
    }
  }

  .rbc-now {
    .rbc-button-link {
      border-radius: 6px;
      background: #fd8a24;
      padding: 2px 4.5px !important;
      color: ${COLOR_CONFIG.white} !important;
    }
  }

  .rbc-off-range {
    .rbc-button-link {
      color: ${COLOR_CONFIG['neutral-text']} !important;
    }
  }

  .rbc-off-range-bg {
    background: ${COLOR_CONFIG.white};
  }

  .rbc-button-link {
    font-weight: 600;
    font-size: 12px !important;
    line-height: calc(16 / 12);
  }

  .rbc-event {
    border-radius: 4px;
    padding: 2px 8px;
    min-height: 22px;
  }

  .rbc-event-content {
    p {
      color: ${COLOR_CONFIG.white};
      font-weight: 600;
      font-size: 12px;
      line-height: calc(16 / 12);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .es-calendar-input {
    width: 100% !important;
  }

  .text-class-lesson .rbc-event-content p {
    color: ${COLOR.purpel['purpel-6']};
  }

  .text-challenge .rbc-event-content p {
    color: ${COLOR_CONFIG.white};
  }

  .text-other-events .rbc-event-content p {
    color: ${COLOR_CONFIG.magenta};
  }
`;

export const FilterPanelContainer = styled.div`
  width: 20.7%;
`;

export const PillButton = styled.span<{ color: string }>`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: ${({ color }) => color};
  margin-top: 3px;
`;
